<mat-dialog-content>
  <h2>
    <strong>{{ 'Segment List' | translate }}</strong>
  </h2>
  <form>
    @if (listSegments.length > 0) {
      <table class="table table-bordered">
        <thead class="thead-dark">
          <tr>
            <th>
              <mat-label>Item</mat-label>
            </th>
            <th>
              <mat-label>{{ 'Segment' | translate }}</mat-label>
            </th>
            <th>
              <mat-label>{{ 'Options' | translate }}</mat-label>
            </th>
          </tr>
        </thead>
        <tbody>
          @for (segment of listSegments; track segment; let i = $index) {
            <tr>
              <td data-label="Item">
                {{ i + 1 }}
              </td>
              <td data-label="Group">
                {{ segment.nombre }}
              </td>
              <td data-label="Options">
                <button
                  (click)="remove(segment.id_segment, i)"
                  mat-raised-button
                >
                  x
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
    <br />
    @if (listSegments.length <= 0) {
      <div class="alert alert-danger">
        {{ 'NO RECORDS FOUND' | translate }}
      </div>
    }
    <br />
    <form [formGroup]="registerForm">
      <table class="table table-bordered">
        <thead class="thead-dark">
          <tr>
            <th>
              <mat-label>{{ 'Add Segment' | translate }}</mat-label>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-label="Add Group">
              <input
                style="width: 200px"
                class="form-control"
                type="text"
                formControlName="segment"
              />
              @if (textValid('segment')) {
                <span class="form-text text-danger">{{
                  'Segment invalid' | translate
                }}</span>
              }
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <button
        mat-raised-button
        (click)="update()"
        style="margin-left: 20px; margin-bottom: 20px"
      >
        {{ 'Add' | translate }}
      </button>
      <button
        mat-raised-button
        mat-dialog-close
        style="margin-left: 20px; margin-bottom: 20px"
      >
        {{ 'Close' | translate }}
      </button>
    </form>
  </form>
</mat-dialog-content>
